import React, { PureComponent } from "react";
import Select from "react-select";

import numeral from "numeral";

import { Button, ButtonGroup, Dropdown, Icon } from "aible";
import { LineInput } from "components/Inputs/LineInput";
import Toggle from "react-toggle";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

import { AIBLE_VIEW_TYPE, isSameSetup } from "containers/Project/reducer";

import TinyBarChart from "components/Project/TinyBarChart";
import PieChart from "components/Project/PieChart";

import ModelBoxContainer from "containers/Business/ModelBox/ModelBox";
import ModelContainer from "containers/Business/ModelBox/Model";
import ModelLabels from "components/Business/ModelBox/ModelLabels";
import BaselineCostsCard from "containers/UnifiedProject/RealityCheck/BaselineCostsCard";
import ImpliedStrategy from "containers/UnifiedProject/RealityCheck/ImpliedStrategy";

import RealityCheckContainer from "containers/Business/RealityCheck/RealityCheck";
import RealityCheckCard from "containers/UnifiedProject/RealityCheck/RealityCheckCard";

import ProjectHelp from "containers/UnifiedProject/Help/ProjectHelp";
import ProjectHelpItem from "components/UnifiedProject/Help/ProjectHelpItem";

import styles from "./style.module.css";

export default class NextOptimization extends React.PureComponent {
  constructor(props) {
    super(props);

    const { setup } = this.props;

    this.state = {
      isHammer: false
    };
  }

  renderMix() {
    const {
      project,
      createSplits,
      optimized,
      optimizer,
      splitOptions,
      isContinuous,
      modelGroups,
      updateDrilldownValue
    } = this.props;
    const { isCreating } = this.state;

    const drilldownValues = (modelGroups && modelGroups.drilldownValues && modelGroups.drilldownValues) || [];

    let drilldownSlice = undefined;

    for (let value of drilldownValues) {
      if (
        value.value != "Overall" &&
        (optimizer.drilldownValue == "Overall" || value.value === optimizer.drilldownValue)
      ) {
        drilldownSlice = value;
        break;
      }
    }

    const otherSlices = drilldownSlice
      ? drilldownValues.filter((v) => v && v.column && v.column == drilldownSlice.column && v.column !== "Overall")
      : undefined;

    let loadingSplits = false;

    otherSlices &&
      otherSlices.forEach((v) => {
        if (isNaN(v.optimalPct)) {
          loadingSplits = true;
        }
      });

    const darkSelectStyle = {
      option: (provided, state) => ({
        ...provided,
        background: state.isFocused ? "#512f77" : "#362e30",
        color: "white !important"
      }),
      control: (provided, state) => ({
        ...provided,
        background: "#362e44",
        border: "1px solid #828282",
        color: "white !important"
        // none of react-select's styles are passed to <Control />
      }),
      singleValue: (provided, state) => ({
        ...provided,
        color: "white"
      }),
      menuList: (provided, state) => ({
        ...provided,
        paddingTop: "0px",
        paddingBottom: "0px"
      })
    };

    const pieData = otherSlices
      ? otherSlices.map((s) => ({
          name: s.value,
          runId: s.runId,
          value: Math.round(s.optimalPct),
          color: s.color
        }))
      : [];

    return (
      <div className={styles.mixHolder} style={{ overflow: "visible" }}>
        {project && project.segments && project.segments.length === 1 && isCreating !== true ? (
          <div className={styles.splitFieldHolder}>
            <div className={styles.oItemBotHeader} style={{ textAlign: "center" }}>
              {"Split on Field"}
            </div>
            <div className={styles.splitField}>
              <Select options={splitOptions} ref="splitOne" styles={darkSelectStyle} />
            </div>
            <Button
              onClick={() => {
                this.setState({ isCreating: true });
                setTimeout(() => this.setState({ isCreating: false }), 5000);
                createSplits(
                  this.refs["splitOne"].state.value !== null ? this.refs["splitOne"].state.value.value : undefined
                );
              }}
              style={{ whiteSpace: "nowrap" }}
              isDark
            >
              {"Create Subgroups"}
            </Button>
          </div>
        ) : (!isContinuous && loadingSplits) || isCreating ? (
          <div className={styles.smallLoader} style={{ padding: "2vw" }}>
            <LoadingIndicator style={{ marginTop: "-20px" }} color={"#868595"} />
            <div style={{ fontWeight: "300", marginTop: "-10px" }}>{"Training AI Models"}</div>
          </div>
        ) : isContinuous ? (
          <React.Fragment />
        ) : pieData.find((e) => e.value) ? (
          <div>
            <div className={styles.pieHolder}>
              <PieChart
                showSegments
                pData={pieData}
                onClick={(runId, name) => updateDrilldownValue(runId, name)}
                unit={optimized.unitLabelShort}
              />
            </div>
          </div>
        ) : (
          <React.Fragment />
        )}
      </div>
    );
  }

  getBaselines() {
    const { id, setup, runId } = this.props;

    const { truePositive, falsePositive, trueNegative, falseNegative } = this.getCounts(true);

    const pursued = truePositive + falsePositive;
    const notPursued = trueNegative + falseNegative;

    const baselineTotal = pursued + notPursued;

    const bPositives = truePositive + falseNegative;
    const bNegatives = falsePositive + trueNegative;

    const baselineTotalWinRate = ((bPositives / (bPositives + bNegatives)) * 100).toFixed(2);

    return {
      baselineWinRate: baselineTotalWinRate,
      baselineTotal: baselineTotal
    };
  }

  getIsOverallSegment() {
    const { project, optimized } = this.props;

    return (
      optimized &&
      optimized.innerSegment &&
      optimized.innerSegment.conditions.length === 0 &&
      optimized.innerSegment.job &&
      optimized.innerSegment.job.job_id === optimized.innerId &&
      project &&
      project.segments &&
      project.segments.length > 1
    );
  }

  renderProgress(label) {
    const { optimized } = this.props;

    return (
      <div className={styles.eLight}>
        <div className={styles.lFlex}>
          <div className={styles.eCircle} />
          {optimized && optimized.isCreating ? "Finding Optimal " + label : "Optimization Not Started"}
        </div>
        <div className={styles.eLightBar} />
      </div>
    );
  }

  // Uses subgroup counts to make overall counts if overall
  getCounts(isBaseline = false) {
    const { setup, modelGroups } = this.props;

    if (!this.getIsOverallSegment()) {
      const countsObj = isBaseline && setup.isRealityHammer && setup.baselineCounts ? setup.baselineCounts : setup;
      return {
        truePositive: Number(countsObj.truePositive),
        falsePositive: Number(countsObj.falsePositive),
        trueNegative: Number(countsObj.trueNegative),
        falseNegative: Number(countsObj.falseNegative)
      };
    }
    const retCounts = {
      truePositive: 0,
      falsePositive: 0,
      trueNegative: 0,
      falseNegative: 0
    };
    modelGroups.drilldownValues
      .filter((d) => d.value !== "Overall")
      .map((d) => d.setup)
      .forEach((currSetup) => {
        const countsObj =
          isBaseline && currSetup.isRealityHammer && currSetup.baselineCounts ? currSetup.baselineCounts : currSetup;
        retCounts.truePositive = retCounts.truePositive + Number(countsObj.truePositive);
        retCounts.falsePositive = retCounts.falsePositive + Number(countsObj.falsePositive);
        retCounts.trueNegative = retCounts.trueNegative + Number(countsObj.trueNegative);
        retCounts.falseNegative = retCounts.falseNegative + Number(countsObj.falseNegative);
      });
    return retCounts;
  }

  renderTop() {
    const {
      id,
      approvedScenario,
      isContinuous,
      getIsContinuous,
      currentSpend,
      currentRevenue,
      currentProfit,
      setup,
      isEditBlueprint,
      isBalance,
      hasLinkedProject,
      linkedProject,
      linkedProjectOutputModeOption,
      linkedProjectOutputModeOptions,
      isLoadingLink,
      optimized,
      optimizer,
      isRealityHammer,
      project,
      modelGroups,
      runId,
      model,
      projects,
      setMaxBudget,
      setMinBudget,
      updateLinkedProjectId,
      updateScaledTotal,
      updateOutcomePercentage,
      updateIsRealityHammer,
      updateHasLinkedProject,
      updateNetImpactLabel,
      updateAdvancedCostLabel,
      updateAdvancedRevenueLabel,
      updateAdvancedProfitLabel,
      updateLinkedScenarioId,
      updateLinkedProjectOutputMode,
      history,
      goToBalance,
      transactionLabel,
      truePositiveLabel,
      outcomeLabel
    } = this.props;

    const { isHammer, isCompare, isDrivers } = this.state;

    const { truePositive, falsePositive, trueNegative, falseNegative } = this.getCounts();
    const pursued = Number(truePositive) + Number(falsePositive);
    const notPursued = Number(trueNegative) + Number(falseNegative);
    const total = pursued + notPursued;

    const positives = Number(truePositive) + Number(falseNegative);
    const negatives = Number(falsePositive) + Number(trueNegative);

    const totalWinRate =
      positives + negatives !== 0
        ? ((positives / (positives + negatives)) * 100).toFixed(2)
        : setup.outcomePercentage === undefined
          ? 0
          : setup.outcomePercentage * 100;

    const minBudget =
      project &&
      project.settings.segmentMinBudgets &&
      project.settings.segmentMinBudgets[optimized.segmentId] !== undefined
        ? project.settings.segmentMinBudgets[optimized.segmentId]
        : undefined;

    const maxBudget =
      project &&
      project.settings.segmentMaxBudgets &&
      project.settings.segmentMaxBudgets[optimized.segmentId] !== undefined
        ? project.settings.segmentMaxBudgets[optimized.segmentId]
        : undefined;

    const isOverallSegment = this.getIsOverallSegment();

    const retIsContinuous = isContinuous || (optimized && optimized.underEstimate !== undefined);

    const mSubGroup =
      optimizer &&
      modelGroups &&
      optimizer.drilldownValue &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter((d) => d.value === optimizer.drilldownValue).length > 0
        ? modelGroups.drilldownValues.filter((d) => d.value === optimizer.drilldownValue)[0]
        : undefined;

    const unitType = setup.unitType !== undefined ? setup.unitType : "$";

    const isSkipped =
      approvedScenario &&
      optimized &&
      isSameSetup(approvedScenario.data, optimized.setup) &&
      setup &&
      setup.isFastTrain;

    const baselines = this.getBaselines();

    return (
      <div className={styles.emptyTop}>
        {isBalance ? (
          <div className={styles.pTitle}>{"Enterprise Resourcing Balancing & Optimization"}</div>
        ) : (
          <ProjectHelp
            title={
              isEditBlueprint
                ? "Editing Blueprint: Business Cost Benefits and Labels"
                : "Add Business Assumptions to Optimize the AI Business Impact"
            }
            isDark
            onToggle={(isClosed) => this.setState({ isHelpClosed: isClosed })}
            noBot
          >
            {isEditBlueprint !== true && (
              <ProjectHelpItem isDark type={"targetGrey"}>
                {"After Training the AI Aible will show the recommended resourcing, " +
                  "mix, and revenue that optimizes your profit and compares it to the baseline."}
              </ProjectHelpItem>
            )}
            {isEditBlueprint !== true && (
              <ProjectHelpItem isDark type={"rocketGrey"}>
                {"You will be able to keep changing these assumptions even after training the AI."}
              </ProjectHelpItem>
            )}
          </ProjectHelp>
        )}
        <div className={styles.eBoxHolder}>
          {isEditBlueprint ? (
            <div className={styles.eBox}>
              <div className={styles.eDark}>
                <LineInput
                  isMediumBox
                  isDark
                  defaultValue={
                    optimized
                      ? optimized.resourcingLabel
                      : setup && setup.resourcingLabel
                        ? setup.resourcingLabel
                        : "Resourcing"
                  }
                  onChange={(val) => {
                    updateAdvancedCostLabel(runId, val);
                    updateAdvancedCostLabel("new", val);
                  }}
                />
              </div>
              <div className={styles.eLightLarge}>{"TBD"}</div>
              <div>{"TBD"}</div>
            </div>
          ) : optimized && optimized.isCreating === false ? (
            <div className={styles.eBox}>
              <div className={styles.eDark}>{optimized.resourcingLabel}</div>
              <div className={styles.eLightLarge}>
                {optimized.isCurrencyUnitType ? (
                  <div>
                    {unitType}
                    {numeral(optimized.totalCost).format("0.0a")}
                  </div>
                ) : (
                  <div className={styles.nonC}>
                    {numeral(optimized.totalCost).format("0.0a")}
                    <div className={styles.subLabel}>{unitType}</div>
                  </div>
                )}
              </div>
              {isSkipped !== true ? (
                <TinyBarChart
                  bars={[
                    {
                      label: "Optimal " + optimized.resourcingLabel,
                      Cost: optimized.totalCost
                    },
                    {
                      label: "Current " + optimized.resourcingLabel,
                      Cost: optimized.currentSpend
                    }
                  ]}
                  unit={optimized.unitLabel}
                  isCurrencyUnit={optimized.isCurrencyUnitType}
                />
              ) : (
                <div>{"Add baseline assumptions to show difference"}</div>
              )}
            </div>
          ) : optimized && optimized.isCreating ? (
            <div className={styles.eBox}>
              <div className={styles.eDark}>{optimized.resourcingLabel}</div>
              <div className={styles.eLoading}>
                <LoadingIndicator style={{ margin: "0px" }} color={"#868595"} />
              </div>
              {this.renderProgress("Resourcing")}
            </div>
          ) : (
            <div className={styles.eBox}>
              <div className={styles.eDark}>{"Baseline Resourcing"}</div>
              <div className={styles.eSubDark}>
                {"This is your Business Assumptions Costs (the total cost " +
                  "per opportunity) times the Total Opportunities " +
                  "you expect to pursue."}
              </div>
              <div className={styles.eDarkLarge}>
                {unitType === "$" ? (
                  <div>
                    {unitType}
                    {numeral(currentSpend).format("0.0a")}
                  </div>
                ) : (
                  <div className={styles.nonC}>
                    {numeral(currentSpend).format("0.0a")}
                    <div className={styles.subLabel}>{unitType}</div>
                  </div>
                )}
              </div>
            </div>
          )}
          {isEditBlueprint ? (
            <div className={styles.eBox}>
              <div className={styles.eDark}>{"Recommended Mix"}</div>
            </div>
          ) : optimized && optimized.isCreating === false ? (
            <div className={styles.eBox}>
              <div className={styles.eDark}>{"Recommended Mix"}</div>
              {this.renderMix()}
            </div>
          ) : optimized && optimized.isCreating ? (
            <div className={styles.eBox} style={{ justifyContent: "flex-start" }}>
              <div className={styles.eDark}>{"Recommended Mix"}</div>
              <div className={styles.eLoading}>
                <LoadingIndicator
                  style={{
                    margin: "0px",
                    marginTop: "10px"
                  }}
                  color={"#868595"}
                />
              </div>
            </div>
          ) : (
            <div
              className={styles.eBox}
              style={{
                justifyContent: "flex-start",
                whiteSpace: "wrap"
              }}
            >
              <div className={styles.eDark}>{"Recommended Mix"}</div>
              <div className={styles.eSubDark}>
                {"Aible will show the optimal resource allocation once the AI has been trained."}
              </div>
            </div>
          )}
          {isBalance ? (
            <div style={{ display: "none" }} />
          ) : isEditBlueprint ? (
            <div className={styles.eBox}>
              <div className={styles.eDark}>
                <LineInput
                  isMediumBox
                  isDark
                  defaultValue={
                    optimized
                      ? optimized.revenueLabel
                      : setup && setup.advancedRevenueLabel
                        ? setup.advancedRevenueLabel
                        : "Revenue"
                  }
                  onChange={(val) => {
                    updateAdvancedRevenueLabel(runId, val);
                    updateAdvancedRevenueLabel("new", val);
                  }}
                />
              </div>
              <div className={styles.eLightLarge}>{"TBD"}</div>

              <div>{"TBD"}</div>
            </div>
          ) : optimized && optimized.isCreating === false ? (
            <div className={styles.eBox}>
              <div className={styles.eDark}>{optimized.revenueLabel}</div>
              <div className={styles.eLightLarge}>
                {optimized.isCurrencyUnitType ? (
                  <div>
                    {unitType}
                    {numeral(optimized.revenue).format("0.0a")}
                  </div>
                ) : (
                  <div className={styles.nonC}>
                    {numeral(optimized.revenue).format("0.0a")}
                    <div className={styles.subLabel}>{unitType}</div>
                  </div>
                )}
              </div>
              {isSkipped !== true ? (
                <TinyBarChart
                  bars={[
                    {
                      label: "Optimal " + optimized.revenueLabel,
                      Cost: optimized.revenue
                    },
                    {
                      label: "Current " + optimized.revenueLabel,
                      Cost: optimized.currentRevenue
                    }
                  ]}
                  unit={optimized.unitLabel}
                  isCurrencyUnit={optimized.isCurrencyUnitType}
                />
              ) : (
                <div>{"Add baseline assumptions to show difference"}</div>
              )}
            </div>
          ) : optimized && optimized.isCreating ? (
            <div className={styles.eBox}>
              <div className={styles.eDark}>{optimized.revenueLabel}</div>
              <div className={styles.eLoading}>
                <LoadingIndicator style={{ margin: "0px" }} color={"#868595"} />
              </div>
              {this.renderProgress(optimized.revenueLabel)}
            </div>
          ) : (
            <div className={styles.eBox}>
              <div className={styles.eDark}>{"Baseline Revenue"}</div>
              <div className={styles.eSubDark}>
                {"This uses your Business Assumption Benefits (expected revenue " +
                  "per opportunitiy) times your Total Expected Win Count."}
              </div>
              <div className={styles.eDarkLarge}>
                {unitType === "$" ? (
                  <div>
                    {unitType}
                    {numeral(currentRevenue).format("0.0a")}
                  </div>
                ) : (
                  <div className={styles.nonC}>
                    {numeral(currentRevenue).format("0.0a")}
                    <div className={styles.subLabel}>{unitType}</div>
                  </div>
                )}
              </div>
            </div>
          )}
          {isEditBlueprint ? (
            <div className={styles.eBox}>
              <div className={styles.eDark}>
                <LineInput
                  isMediumBox
                  isDark
                  defaultValue={
                    optimized ? optimized.profitLabel : setup && setup.netImpactLabel ? setup.netImpactLabel : "Profit"
                  }
                  onChange={(val) => {
                    updateNetImpactLabel(runId, val);
                    updateNetImpactLabel("new", val);
                  }}
                />
              </div>
              <div className={styles.eLightLarge}>{"TBD"}</div>
              <div>{"TBD"}</div>
            </div>
          ) : optimized && optimized.isCreating === false ? (
            <div className={styles.eBox}>
              <div className={styles.eDark}>{optimized.profitLabel}</div>
              <div className={styles.eLightLarge}>
                {optimized.isCurrencyUnitType ? (
                  <div>
                    {unitType}
                    {numeral(optimized.profit).format("0.0a")}
                  </div>
                ) : (
                  <div className={styles.nonC}>
                    {numeral(optimized.profit).format("0.0a")}
                    <div className={styles.subLabel}>{unitType}</div>
                  </div>
                )}
              </div>
              {isSkipped !== true ? (
                <TinyBarChart
                  bars={[
                    {
                      label: "Optimal " + optimized.profitLabel,
                      Cost: optimized.profit
                    },
                    {
                      label: "Current " + optimized.profitLabel,
                      Cost: optimized.currentProfit
                    }
                  ]}
                  unit={optimized.unitLabel}
                  isCurrencyUnit={optimized.isCurrencyUnitType}
                />
              ) : (
                <div>{"Add baseline assumptions to show difference"}</div>
              )}
            </div>
          ) : optimized && optimized.isCreating ? (
            <div className={styles.eBox}>
              <div className={styles.eDark}>{optimized.profitLabel}</div>
              <div className={styles.eLoading}>
                <LoadingIndicator style={{ margin: "0px" }} color={"#868595"} />
              </div>
              {this.renderProgress(optimized.profitLabel)}
            </div>
          ) : (
            <div className={styles.eBox}>
              <div className={styles.eDark}>{"Baseline Profit"}</div>
              <div className={styles.eSubDark}>
                {"This is the sum of the unique businesss circumstances you defined" +
                  " in the Costs/Benefits and Expected Win Count across all" +
                  " potential opportunities."}
              </div>
              <div className={styles.eDarkLarge}>
                {unitType === "$" ? (
                  <div>
                    {unitType}
                    {numeral(currentProfit).format("0.0a")}
                  </div>
                ) : (
                  <div className={styles.nonC}>
                    {numeral(currentProfit).format("0.0a")}
                    <div className={styles.subLabel}>{unitType}</div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
  renderOverallContent() {
    const {
      id,
      runId,
      optimized,
      setup,
      modelGroups,
      updateDrilldownValue,
      updateBusinessMode,
      setupLabels,
      businessMode
    } = this.props;

    const { mode } = this.state;

    return (
      <div>
        {this.renderHeaderTabs()}
        <div
          className={styles.oContentOverall + " " + (optimized ? styles.oContentScroll : "")}
          style={{ paddingTop: "20px" }}
        >
          {modelGroups && modelGroups.drilldownValues && (
            <div className={styles.mHolder}>
              <ModelLabels
                mode={businessMode}
                setup={setup}
                setupLabels={setupLabels}
                optimized={optimized}
                businessAssumptions
              />
            </div>
          )}

          {modelGroups &&
            modelGroups.drilldownValues &&
            modelGroups.drilldownValues
              .filter((d) => d.column !== "Overall")
              .map((d, i) => (
                <div className={styles.mHolder} key={d.runId}>
                  <ModelContainer
                    data={d}
                    mode={businessMode}
                    modelGroups={modelGroups}
                    model={d.bestModel}
                    optimized={optimized}
                    updateDrilldownValue={updateDrilldownValue}
                    clickable={true}
                    setupLabels={setupLabels}
                    updateShowImpact
                    businessAssumptions
                  />
                </div>
              ))}
        </div>
        <div className={styles.mBox}>
          <ModelBoxContainer id={id} runId={runId} isNextStrategy businessAssumptions />
        </div>
      </div>
    );
  }

  renderHeaderTabs() {
    const { businessMode, updateBusinessMode, isOverallSegment } = this.props;
    return (
      <div
        className={styles.pTitle}
        style={{
          marginTop: "10px",
          paddingTop: "10px",
          marginBottom: "5px",
          position: "absolute"
        }}
      >
        {`Optimize the AI for your business by defining your baseline behavior`}
      </div>
    );
    /*return (
      <React.Fragment>
        <div className={styles.headerTabs}>
          <ButtonGroup>
            <Button
              active={businessMode === "OVERVIEW" || businessMode === undefined}
              onClick={() => updateBusinessMode("OVERVIEW")}
            >
              {"Overview"}
            </Button>
            <Button
              active={businessMode === "MODEL"}
              onClick={() => updateBusinessMode("MODEL")}
            >
              {"Optimal Model"}
            </Button>
            <Button
              active={businessMode === "DETAILS"}
              onClick={() => updateBusinessMode("DETAILS")}
            >
              {"`Optimal Model Details`"}
            </Button>
          </ButtonGroup>
        </div>
        </React.Fragment>
    );*/
  }

  renderContinuous() {
    const { id, runId, businessMode, optimized, modelGroups, isOverallSegment } = this.props;

    const activeSlice =
      modelGroups && modelGroups.drilldownValues
        ? modelGroups.drilldownValues.find((d) => d.runId === runId)
        : undefined;

    return (
      <div className={styles.pHolder}>
        {optimized && isOverallSegment ? (
          <div className={styles.oContent}>
            <div className={styles.scrollBox}>
              {modelGroups &&
                modelGroups.drilldownValues &&
                modelGroups.drilldownValues
                  .filter((d) => d.column !== "Overall" || modelGroups.drilldownValues.length === 1)
                  .map((d, i) => (
                    <div className={styles.mHolder} key={d.runId}>
                      <ModelBoxContainer
                        id={id}
                        runId={d.runId}
                        businessAssumptions
                        isContinuous
                        title={d.value}
                        isMini
                      />
                    </div>
                  ))}
            </div>
            <div className={styles.modelBox}>
              <ModelBoxContainer id={id} runId={runId} businessAssumptions isContinuous />
            </div>
          </div>
        ) : optimized ? (
          <React.Fragment>
            <div className={styles.oContent}>
              <div className={styles.cRealities}>
                <RealityCheckContainer id={id} runId={runId} isContinuous businessAssumptions />
              </div>
              <div className={styles.modelBox}>
                <ModelBoxContainer id={id} runId={runId} businessAssumptions isContinuous />
              </div>
            </div>
          </React.Fragment>
        ) : (
          <LoadingIndicator />
        )}
      </div>
    );
  }

  renderIntrospectData() {
    const { runId, fields, introspectCountsFromData, dataset } = this.props;

    const { introspectColumn, introspectColumnValue } = this.state || {};

    const datasetOutcome = dataset && dataset.outcome;

    return (
      <div className={styles.introspectSelectionContainer}>
        <div style={{ fontWeight: "bold", fontSize: "16px", marginBottom: "10px" }}>Introspect Data</div>
        <ImpliedStrategy id={runId} />
        <div style={{ display: "flex", marginTop: "10px" }}>
          <div className={styles.outcomePicker} style={{ fontWeight: "bold" }}>
            Variable
          </div>
          <div className={styles.outcomePicker} style={{ fontWeight: "bold" }}>
            Value
          </div>
        </div>
        <div className={styles.optionsSelect}>
          <Select
            value={introspectColumn === undefined ? undefined : { value: introspectColumn, label: introspectColumn }}
            onChange={(v) =>
              this.setState({
                introspectColumn: v.value,
                introspectColumnValue: undefined
              })
            }
            options={
              fields
                ? Object.keys(fields)
                    .filter(
                      (d) =>
                        fields[d].type === "categorical" &&
                        fields[d].data &&
                        fields[d].data.length == 2 &&
                        fields[d].label !== datasetOutcome
                    )
                    .map((d) => ({
                      label: d,
                      value: d
                    }))
                : []
            }
            className={styles.outcomePicker}
            placeholder={"Select Column to Introspect Counts"}
            label="Column"
            menuPlacement="top"
          />
          <Select
            isDisabled={introspectColumn === undefined}
            value={
              introspectColumnValue === undefined
                ? null
                : { value: introspectColumnValue, label: introspectColumnValue }
            }
            onChange={(v) => this.setState({ introspectColumnValue: v.value })}
            options={((fields || {})[introspectColumn] || { data: [] }).data.map(({ value }) => ({
              label: value,
              value: value
            }))}
            className={styles.outcomePicker}
            placeholder={"Select Success Value"}
            label="Success Value"
            menuPlacement="top"
          />
        </div>
        <div className={styles.introspectSelectionButtonRow}>
          <Button
            disabled={introspectColumn === undefined || introspectColumnValue === undefined}
            onClick={() => introspectCountsFromData(runId, introspectColumn, introspectColumnValue)}
          >
            Introspect
          </Button>
        </div>
      </div>
    );
  }

  render() {
    const {
      id,
      runId,
      businessMode,
      modelGroups,
      setupLabels,
      isContinuous,
      isOverallSegment,
      project,
      updateUsePercentages,
      updateApplyOverall,
      updateMadLibs,
      setup
    } = this.props;

    // if (isContinuous) {
    //   return this.renderContinuous();
    // }

    const usingPercentages =
      project && project.settings && project.settings.usePercentages !== undefined
        ? project.settings.usePercentages
        : true;

    const applyOverall =
      project && project.settings && project.settings.applyOverall ? project.settings.applyOverall : false;

    const hasSplits =
      modelGroups &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter((group) => group.label !== "Overall").length > 0;

    console.log("opt", this.props);

    return (
      <div className={styles.pHolder}>
        {setup ? (
          <React.Fragment>
            <div className={styles.oContent} style={{ backgroundColor: "rgb(229, 229, 229)" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  paddingBottom: "10px"
                }}
                id={"nextOptimizationHolder"}
              >
                <div
                  className={styles.oContent}
                  style={{
                    width: "100%",
                    margin: "10px",
                    display: "flex",
                    flexDirection: "column",
                    backgroundColor: "#FFF",
                    overflowX: "scroll"
                  }}
                >
                  {/*this.renderHeaderTabs()*/}
                  <div className={styles.realitiesHeader} style={{ position: "relative" }}>
                    {`What is your baseline behavior?`}
                  </div>
                  <div className={styles.realitiesContainer}>
                    {usingPercentages ? (
                      <React.Fragment>
                        <div className={styles.realLabels}>
                          <div style={{ height: hasSplits ? "85px" : "55px" }} />
                          <div>
                            <span>{"What % of "}</span>
                            <span style={{ fontWeight: "bold" }}>{setupLabels.transactionLabel}</span>
                            <span>{" do you "}</span>
                            <span style={{ fontWeight: "bold" }}>{setupLabels.trueAction}</span>
                          </div>
                          <div style={{ marginTop: "55px" }}>
                            <span>{"For the "}</span>
                            <span style={{ fontWeight: "bold" }}>{setupLabels.transactionLabel}</span>
                            <span>{" you "}</span>
                            <span style={{ fontWeight: "bold" }}>{setupLabels.trueAction}</span>
                            <span>{" what is your "}</span>
                            <span style={{ fontWeight: "bold" }}>{setupLabels.outcomeLabel}</span>
                            <span>{" rate "}</span>
                          </div>
                          <div style={{ marginTop: "50px" }}>
                            <span>{"The potential "}</span>
                            <span style={{ fontWeight: "bold" }}>{setupLabels.outcomeLabel}</span>
                            <span>{" rate for  "}</span>
                            <span style={{ fontWeight: "bold" }}>{setupLabels.transactionLabel}</span>
                            <span>{" you "}</span>
                            <span style={{ fontWeight: "bold" }}>{setupLabels.falseAction}</span>
                          </div>
                        </div>
                        <div className={styles.realities}>
                          {modelGroups &&
                            modelGroups.drilldownValues &&
                            modelGroups.drilldownValues
                              .filter(
                                (d) =>
                                  modelGroups.drilldownValues.length === 1 ||
                                  (isOverallSegment && d.value !== "Overall") ||
                                  (d.runId === runId && isOverallSegment === false && d.value !== "Overall")
                              )
                              .map((d) => (
                                <div key={d.runId} className={styles.realityHolder}>
                                  <RealityCheckContainer
                                    id={id}
                                    runId={d.runId}
                                    activeSlice={d}
                                    businessAssumptions
                                    isNext={true}
                                  />
                                </div>
                              ))}
                        </div>
                      </React.Fragment>
                    ) : (
                      <RealityCheckCard
                        setup={this.props.setup}
                        modelGroups={modelGroups}
                        id={this.props.id}
                        runId={runId}
                        applyOverall={applyOverall}
                      />
                    )}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      margin: "0px 0px 10px 20px",
                      alignItems: "center"
                    }}
                  >
                    <div>Quick Start Options:</div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginLeft: "10px"
                      }}
                    >
                      <input
                        checked={usingPercentages}
                        onChange={() => updateUsePercentages(!usingPercentages)}
                        type="checkbox"
                        style={{ margin: "0px" }}
                      />
                      <span style={{ marginLeft: "10px" }}>Use Percentages</span>
                    </div>
                    {!usingPercentages &&
                      modelGroups &&
                      modelGroups.drilldownValues &&
                      modelGroups.drilldownValues.length > 1 && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginLeft: "10px"
                          }}
                        >
                          <Toggle checked={applyOverall} onChange={() => updateApplyOverall(!applyOverall)} />
                          <span style={{ marginLeft: "10px" }}>Apply overall to all sub groups</span>
                        </div>
                      )}
                  </div>
                  {/*this.renderIntrospectData()*/}
                </div>
                {modelGroups && (
                  <BaselineCostsCard modelGroups={modelGroups} runId={runId} id={this.props.id} project={project} />
                )}
              </div>
            </div>
          </React.Fragment>
        ) : (
          <LoadingIndicator />
        )}
      </div>
    );
  }
}
